import { randCompanyName, randSentence } from '@ngneat/falso';
import { initVersionedSchema, MixedSchema } from '@principle-theorem/editor';
import {
  IPartner,
  PartnerStatus,
} from '@principle-theorem/principle-core/interfaces';
import {
  BaseFirestoreMock,
  Properties,
  Region,
} from '@principle-theorem/shared';

export class PartnerMock
  extends BaseFirestoreMock<Properties<Omit<IPartner, 'appIconUrl'>>>
  implements Properties<Omit<IPartner, 'appIconUrl'>>
{
  name = randCompanyName();
  status = PartnerStatus.Test;
  regions: Region[] = [Region.Australia];
  description: MixedSchema = initVersionedSchema(randSentence());
  appIconUrl?: string = undefined;
}
